import ArticleCard from '../components/ArticleCard';
import './Home.css';

export const dummyArticles = [
  {
    id: 'Article 1',
    title: 'NBA Finals Game 6: Pacers Force Game 7 with Dominant 108-91 Victory Over Thunder',
    image: '/article-photos/article-1.jpeg',
    date: 'June 19, 2025',
    author: 'Adrian Wojnarowski',
    source: 'ESPN',
    link: 'https://www.espn.com/nba/story/_/id/44610574/nba-finals-2025-postseason-news-scores-highlights',
    content: `
    The Indiana Pacers delivered a statement victory in Game 6, defeating the Oklahoma City Thunder 108-91 to force a decisive Game 7 in the 2025 NBA Finals. With their backs against the wall in an elimination game, the Pacers responded with their most complete performance of the series.

    Obi Toppin led the charge off the bench with 20 points, while Tyrese Haliburton overcame his calf injury to contribute significantly despite playing through pain. The Pacers had six players score in double figures, showcasing the balanced attack that has defined their playoff run.

    Indiana jumped out to a commanding 22-point halftime lead and extended it to 30 points early in the fourth quarter before garbage time set in. The Pacers' ferocious defense completely disrupted Oklahoma City's rhythm, holding Shai Gilgeous-Alexander and the Thunder's high-powered offense well below their season averages.

    "We knew we had to come out with desperation," said Haliburton, who played just 23 minutes due to the blowout nature of the game. "Our backs were against the wall, and we responded like champions."

    The victory marked Indiana's ability to bounce back after dropping Game 5 at home. With momentum now on their side, the Pacers head to Oklahoma City for Game 7 on Sunday, June 22, with a chance to capture their first NBA championship since their ABA days.

    Game 7 tips off at 8 p.m. ET on ABC, with the winner claiming the Larry O'Brien Trophy. The Thunder, who held a 3-2 series lead, must now win on their home court to avoid one of the biggest collapses in Finals history.
    `,
    summary: '',
  },
  {
    id: 'Article 2',
    title: 'Shai Gilgeous-Alexander and Thunder Make History with Record-Breaking Season',
    image: '/article-photos/article-2.png',
    date: 'June 18, 2025',
    author: 'Shams Charania',
    source: 'The Athletic',
    link: 'https://www.nba.com/news/2025-nba-finals-game-6-preview',
    content: `
    The Oklahoma City Thunder have already made history this season, breaking the NBA record for most points scored in a single season including playoffs. Shai Gilgeous-Alexander's free throw in Game 4 of the NBA Finals officially sealed the record, surpassing the previous mark held by the Golden State Warriors.

    This achievement caps off a remarkable regular season where the Thunder posted a franchise-best 68 wins, led by Gilgeous-Alexander's MVP-caliber performance averaging 32.7 points per game. The young superstar has elevated his game throughout the playoffs, including a dominant 35-point performance in Game 4 that helped tie the series.

    "SGA has been incredible all year," said Thunder coach Mark Daigneault. "His leadership and growth have been the foundation of everything we've built here over the past five years."

    The Thunder's success has been built on their league-leading defense, which has created problems for every opponent this postseason. In their three Finals victories, Oklahoma City has forced 71 points off turnovers while giving up just 49, showcasing their ability to create chaos and capitalize on opponents' mistakes.

    Chet Holmgren, Jalen Williams, and Lu Dort have formed a formidable defensive core around Gilgeous-Alexander, with the team's young roster bringing energy and athleticism that has overwhelmed more experienced teams throughout the playoffs.

    As the Thunder prepare for Game 7, they're one win away from their first championship since the franchise moved from Seattle. The team that was rebuilt through smart drafting and player development now stands on the precipice of basketball immortality.
    `,
    summary: '',
  },
  {
    id: 'Article 3',
    title: 'Tyrese Haliburton Battles Through Injury in Historic Pacers Finals Run',
    image: '/article-photos/article-3.jpeg',
    date: 'June 17, 2025',
    author: 'Brian Windhorst',
    source: 'ESPN',
    link: 'https://bleacherreport.com/articles/25210837-indiana-pacers-vs-oklahoma-city-thunder-bold-predictions-2025-nba-finals-game-7',
    content: `
    Tyrese Haliburton's journey to the NBA Finals has been remarkable, but his performance while battling a calf strain has elevated him to legendary status in Indiana. The All-Star point guard, who has 13 field goals to tie or take the lead in fourth quarters or overtime this postseason, continues to deliver clutch moments despite obvious physical limitations.

    Haliburton's game-winning shot in Game 1 of the Finals announced the Pacers' arrival on basketball's biggest stage. His leadership throughout the playoffs, averaging 20.5 points and 12.8 assists in the postseason, has been the catalyst for Indiana's first Finals appearance since 2000.

    "Tyrese embodies everything we want to be as a team," said Pascal Siakam, who won Eastern Conference Finals MVP. "He plays through pain, he makes everyone better, and he steps up when it matters most."

    The injury occurred during the Eastern Conference Finals against New York, but Haliburton has refused to use it as an excuse. In games where he's been limited, teammates like T.J. McConnell and Bennedict Mathurin have stepped up, with Mathurin scoring 27 points off the bench in Game 3.

    Haliburton's story mirrors that of many great players who have overcome adversity. Traded from Sacramento to Indiana in 2022, he has transformed the Pacers' culture and brought championship aspirations to a franchise that has waited over two decades for this moment.

    With Game 7 looming, all eyes will be on whether Haliburton can summon one more magical performance to deliver Indiana its first NBA title in franchise history.
    `,
    summary: '',
  },
  {
    id: 'Article 4',
    title: 'Ben Mathurin Makes Finals History Off the Bench for Pacers',
    image: '/article-photos/article-4.jpeg',
    date: 'June 16, 2025',
    author: 'Tim Bontemps',
    source: 'ESPN',
    link: 'https://economictimes.indiatimes.com/topic/nba-finals',
    content: `
    Bennedict Mathurin has emerged as an unlikely hero for the Indiana Pacers, making NBA Finals history with his performances off the bench. The young guard's 27-point explosion in Game 3 not only helped the Pacers take a 2-1 series lead but also set a record for most points by a reserve in a Finals game for the franchise.

    Mathurin's breakout performance came at the perfect time, with Tyrese Haliburton battling through his calf injury and the team needing a spark at home. Playing alongside veteran T.J. McConnell, who contributed significantly with his veteran savvy, Mathurin provided the energy and scoring punch that lifted the Pacers to their first Finals home victory in 25 years.

    "Ben has been ready for this moment all season," said Pacers coach Rick Carlisle. "His preparation, his work ethic, and his confidence have all led to this breakthrough performance on the biggest stage."

    The second-year player from Arizona has shown remarkable growth throughout the playoffs, providing crucial minutes when the starters needed rest. His athleticism and fearless shooting have given the Pacers another dimension, particularly in their up-tempo offensive system.

    Mathurin's rise mirrors the Pacers' overall journey this season. Like his team, he started slowly but has peaked at the perfect time. His ability to score in bunches and create his own shot has been invaluable against Oklahoma City's stifling defense.

    With the series heading to Game 7, Mathurin's continued production off the bench could be the X-factor that determines whether the Pacers can complete their magical championship run.
    `,
    summary: '',
  },
  {
    id: 'Article 5',
    title: 'Celebrity Spotlight: Caitlin Clark, Reggie Miller Attend Star-Studded Finals Game 3',
    image: '/article-photos/article-5.jpeg',
    date: 'June 15, 2025',
    author: 'Malika Andrews',
    source: 'ESPN',
    link: 'https://economictimes.indiatimes.com/topic/nba-finals',
    content: `
    Game 3 of the NBA Finals in Indianapolis became a star-studded affair, with Indiana Fever sensation Caitlin Clark leading a who's who of basketball royalty in attendance. Clark, accompanied by her Fever teammates, cheered on the Pacers in what marked the first Finals game in Indiana since 2000.

    The WNBA Rookie of the Year candidate, who is recovering from a thigh injury, was joined by Pacers legend Reggie Miller and NBA icon Oscar Robertson, creating a multi-generational celebration of Indiana basketball. The crowd erupted when Clark was shown on the jumbotron, highlighting her impact on the state's basketball culture.

    "Having Caitlin here, having Reggie and Oscar here, it shows what basketball means to Indiana," said Tyrese Haliburton. "This is basketball country, and having our legends support us means everything."

    Internet personality Kai Cenat and NFL star Creed Humphrey were also spotted courtside, adding to the celebrity buzz surrounding the Finals. The attendance of these high-profile figures underscored the national attention the series has generated.

    Clark's presence was particularly meaningful given her own journey to stardom. Like the Pacers, she has faced adversity and criticism but has risen to become one of the most recognizable faces in basketball. Her support for the Pacers reflects the tight-knit basketball community in Indiana.

    The celebrity attendance has added another layer of excitement to what has already been a captivating Finals series, with each game drawing viewers from across sports and entertainment.
    `,
    summary: '',
  },
  {
    id: 'Article 6',
    title: 'Thunder Defense vs Pacers Offense: The X-Factor Battle That Will Decide Game 7',
    image: '/article-photos/article-6.jpeg',
    date: 'June 20, 2025',
    author: 'Zach Lowe',
    source: 'ESPN',
    link: 'https://bleacherreport.com/articles/25210837-indiana-pacers-vs-oklahoma-city-thunder-bold-predictions-2025-nba-finals-game-7',
    content: `
    As Game 7 of the 2025 NBA Finals approaches, the series has crystallized into a classic battle between Oklahoma City's elite defense and Indiana's explosive offense. The Thunder's league-leading defense, anchored by coach Mark Daigneault's five-year system, faces its ultimate test against a Pacers team that has averaged 116 points per game this postseason.

    Oklahoma City's defensive foundation, built on forcing turnovers and controlling the glass, has been their calling card all season. In their three Finals victories, the Thunder have created 23 turnovers leading to 32 points in Game 5 alone, showcasing their ability to create chaos and capitalize on mistakes.

    "There's no new material," Daigneault said. "We're not walking in today with a new riff. We're walking in and pounding away at the same stuff we've been pounding away at for five years."

    The Pacers, meanwhile, are undefeated in the playoffs when scoring over 114 points but winless when falling short of that mark. Their pace-and-space offense, led by Haliburton's playmaking and Siakam's versatility, has proven capable of explosive performances when clicking.

    Game 7 will likely be decided by which team can impose their style. If the Thunder can slow down Indiana's pace and force halfcourt offense, their suffocating defense becomes nearly impenetrable. However, if the Pacers can push tempo and create transition opportunities, their offensive firepower could overwhelm even Oklahoma City's elite defense.

    Both teams have shown remarkable resilience throughout the series, setting up what promises to be an epic conclusion to one of the most compelling Finals matchups in recent memory.
    `,
    summary: '',
  }
];

function Home() {
  return (
    <div style={{ marginLeft: '30px' }}>
      <h2>Check out the latest articles from Lima:</h2>
      <div className="article-grid">
        {dummyArticles.map(article => (
          <ArticleCard key={article.id} {...article} summary={article.content.slice(0,80)+'...'}/>
        ))}
      </div>
    </div>
  );
}

export default Home;
